exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 1200px) {\n.modal-xl[data-v-7b301058] {\n        max-width: 100%;\n}\n.modal-xl .modal-content[data-v-7b301058] {\n        height: 95vh\n}\n}\n@media (min-width: 738px) {\n.modal-xl[data-v-7b301058] {\n        max-width: 100%;\n}\n.modal-xl .modal-content[data-v-7b301058] {\n        height: 95vh\n}\n}\n\n\n", ""]);

// exports
